import React, { useContext } from 'react';

import { useTranslation } from 'react-i18next';

import { StarOutline } from '@mui/icons-material';

import { DCRecord } from '@/@types/lib/dataController';
import MapCardActionButton from '@/ui/MapCard/MapCardActionButton';
import DataController from '@/lib/DataController';
import DialogContext from '@/context/DialogContext/DialogContext';
import GradingDialog from '@/views/Pristupacnost/GradingDialog';

import Grading from '@/models/pristupacnost/grading';

export type OcijeniButtonProps = {
  record: DCRecord;
};

const OcijeniButton = ({ record }: OcijeniButtonProps) => {
  const { t } = useTranslation();

  const { showDialog } = useContext(DialogContext);

  const handleOcijeni = () => {
    const dcGrading = new DataController(Grading, `pristupacnost/poi/${record.id}/grades`);
    showDialog(GradingDialog, {
      // type: type,
      dc: dcGrading,
      mode: 'insert',
      form: 'default',
      // iconClass: faIconClass,
      onClose: () => {},
    });
  };

  return (
    <MapCardActionButton onClick={handleOcijeni} startIcon={<StarOutline />} sx={{ width: 'max-content' }}>
      {t('pristupacnost:buttons.ocijeni')}
    </MapCardActionButton>
  );
};

export default OcijeniButton;
